import { Arrow } from './Arrow';

export function Share() {
  const channels = [
    {
      platform: "Instagram",
      handle: "@dee_uxuidesign",
      url: "https://www.instagram.com/dee_uxuidesign/?hl=en",
      desc: "Visual diaries, process clips, type studies, behind-the-screens of live projects.",
      meta: ["Daily", "12.4k", "Reels + carousels"],
      icon: (
        <svg viewBox="0 0 48 48" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="6" y="6" width="36" height="36" rx="10" />
          <circle cx="24" cy="24" r="8" />
          <circle cx="34" cy="14" r="2" fill="currentColor" />
        </svg>
      ),
    },
    {
      platform: "Medium",
      handle: "@dianahakobyan111",
      url: "https://medium.com/@dianahakobyan111",
      desc: "Long-form essays on UX, product design and the AI-native interfaces taking shape.",
      meta: ["Weekly", "Long reads", "Top writer · UX"],
      icon: (
        <svg viewBox="0 0 48 48" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
          <ellipse cx="14" cy="24" rx="8" ry="10" />
          <ellipse cx="30" cy="24" rx="4" ry="10" />
          <line x1="38" y1="14" x2="38" y2="34" />
        </svg>
      ),
    },
  ];

  return (
    <section className="share" id="share">
      <div className="container">
        <div className="share-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>Off the studio · in public</span>
          <div className="share-head-row">
            <h2 className="display share-title" data-reveal style={{ "--reveal-delay": "80ms" }}>
              Where I<br /><em>share.</em>
            </h2>
            <p className="share-lede" data-reveal style={{ "--reveal-delay": "160ms" }}>
              I share UX/UI, product design &amp; AI tools insights on social. Two channels, two registers — 
              quick + visual on one, slow + written on the other.
            </p>
          </div>
        </div>

        <div className="share-grid">
          {channels.map((c, i) => (
            <a key={c.platform} href={c.url} target="_blank" rel="noopener noreferrer" className="share-card" data-reveal style={{ "--reveal-delay": `${i * 80}ms` }} data-cursor="hover">
              <div className="share-card-top">
                <span className="share-icon">{c.icon}</span>
                <span className="share-arrow"><Arrow size={18} /></span>
              </div>
              <h3 className="display share-platform">{c.platform}</h3>
              <span className="share-handle">{c.handle}</span>
              <p className="share-desc">{c.desc}</p>
              <ul className="share-meta">
                {c.meta.map((m, j) => <li key={j}>{m}</li>)}
              </ul>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
